import { Component, OnInit, ChangeDetectorRef ,Output,Input,EventEmitter} from '@angular/core';
import { labour_returnService } from '../../services/labour_return.service';
import { I18nService } from 'core-app/modules/common/i18n/i18n.service';
import * as XLSX from 'xlsx'



@Component({
  selector:'labour_return-table',
  templateUrl: './labour_return-table.component.html',
  styleUrls: ['./labour_return-table.component.sass']
})
export class labourReturnTableComponent implements OnInit {

  @Input() bgcolor:any
  @Input() numArray:any
  @Input() public saveApprovalContent:any
  @Input() public clomnArray:Array<number> = new Array(32)
  public contentEditable:boolean = false
  public version = location.search.split('?')[1].split('&')[0].split('=')[1]
  constructor(
    public service: labour_returnService,
    public i18n: I18nService,
    ) { 
    }


    ngOnInit() {
      jQuery('.tdborder').css('background',this.bgcolor)
      
    }
    ngAfterViewInit(){
      this.changeApprovalContent()

    }

    changeApprovalContent(){
      if(this.saveApprovalContent){
        let {metum} = this.saveApprovalContent
        let Arr = metum.data
        let tableId:any = document.getElementById('mainTable')
        for(let i:any=0;i<Arr.length;i++){
          const tableNum = this.version =='v17'?45:52
          const rowNum = this.version =='v17'?tableId.children.length-90:tableId.children.length-4
          if(Number(Arr[i][0])>tableNum&&rowNum<Number(Arr[i][0])){
            const pos = tableId.children.length-1
            const row = tableId.insertRow(pos)
            row.innerHTML = this.version =='v17'?this.returnTemplat2(Arr[i][0]):this.returnTemplate(Arr[i][0]);
          }
         for(let j:any=0;j<Arr[i].length;j++){
            if(tableId.children[i] && tableId.children[i].children[j]){
              tableId.children[i].children[j].innerText =Arr[i][j]
            }
         }
        }
        jQuery('#mainTable .tdborder').css({'border':'3px solid #000000','background':this.bgcolor})
        jQuery('#mainTable .noborderbottom').css('border-bottom','0')
        jQuery('#mainTable .noborderleft').css('border-left','0')
        jQuery('#mainTable .nobordertop').css('border-top','0')
      }
    }

  returnTemplate(item:any){
 return `<tr>
        <td class="tdborder" height="53" align="center" valign=middle sdval="${item}"><b>
                <font face="Times New Roman" size=2>${item}</font>
            </b></td>
        <td class="tdborder" align="left" colspan=2 valign=middle><b>
                <font size=2>Others: trade name&nbsp;&nbsp;&nbsp;&nbsp; - code -

                </font>
            </b></td>
            <td class="tdborder" align="center" valign=middle></td>
        <td class="tdborder noborderleft" align="center" valign=middle [contentEditable]="contentEditable"><b>
                <font size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" align="center" valign=middle><b>
                <font face="Times New Roman" size=2>${this.numArray[44]}</font>
            </b></td>
        <td class="tdborder" contentEditable="true" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" contentEditable="true" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" contentEditable="true" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" align="center" valign=bottom sdval="${item}"><b>
                <font face="Times New Roman" size=2>${item}</font>
            </b></td>
    </tr>`
  }
  returnTemplat2(num: any) {
    return `
    <tr>
        <td class="tdborder" height="53" align="center" valign=middle sdval="${num}"><b>
                <font face="Times New Roman" size=2>${num}</font>
            </b></td>
        <td class="tdborder nobordertop" align="left" colspan=3 valign=middle><b>
                <font size=2>Others: trade name &nbsp;&nbsp;&nbsp;&nbsp; - code -</font>
            </b></td>
            <td class="tdborder" align="center" valign=middle></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" [contentEditable]="contentEditable" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" align="center" valign=middle><b>
                <font face="Times New Roman" size=2>${this.numArray[44]}</font>
            </b></td>
        <td class="tdborder" contentEditable="true" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" contentEditable="true" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" contentEditable="true" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" contentEditable="true" align="center" valign=middle><b>
                <font face="Times New Roman" size=2><br></font>
            </b></td>
        <td class="tdborder" align="center" valign=bottom sdval="${num}"><b>
                <font face="Times New Roman" size=2>${num}</font>
            </b></td>
    </tr>`
  }
}